<div ng-controller="stageConfigsController as stageConfigsCtrl" class="stage-configs">
    <c-auto-form config="stageConfigsCtrl.autoFormConfig" class="stage-configs-view"></c-auto-form>
    <div ui-view></div>
</div>